import { JSX, useEffect } from 'react';

import { getLocalStorageItem, setLocalStorageItem } from '@/shared/utils';

import { authUrl } from '../../../api/base';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  useEffect(() => {
    const token = getLocalStorageItem('token');
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');

    if (tokenFromUrl) {
      setLocalStorageItem('token', tokenFromUrl);
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      return;
    }

    if (!token) {
      window.location.href = authUrl;
    }
  }, []);

  return children;
};
